export default __webpack_public_path__ + "static/media/pa_8.765df9bf.mp3";